import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useJoinNetwork = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.auth.joinNetwork(input, fields), useMutationOptions);
};
//# sourceMappingURL=useJoinNetwork.js.map